import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { FOOTER_HEADING_SX } from './styles';

function FooterColumnHeading({ children, mb = 1.5 }) {
    return (
        <Box component="h3" sx={[FOOTER_HEADING_SX, { mb }]}>
            {children}
        </Box>
    );
}

FooterColumnHeading.propTypes = {
    children: PropTypes.node.isRequired,
    mb: PropTypes.number,
};

export default FooterColumnHeading;
